export const BillingTranscriptsColumns = [
    {
        name: '№ акта',
        key: 'actNumber',
    },
    {
        name: 'Дата АВР',
        key: 'actFrom1CCreatedAt',
    },
    {
        name: 'Контрагент',
        key: 'company',
    },
    {
        name: 'Период выставления счетов',
        key: 'billingPeriod',
    },
    {
        name: 'Общая сумма',
        key: 'finalAmount',
    },
    {
        name: 'Согласованты',
        key: 'approvers',
    },
    {
        name: 'Подписанты',
        key: 'signers',
    },
]
